import React, { Component } from "react";

import UserService from "../services/user.service";

export default class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: "",
    };
  }

  componentDidMount() {
    UserService.getPublicContent().then(
      (response) => {
        this.setState({
          content: response.data,
        });
      },
      (error) => {
        this.setState({
          content:
            (error.response && error.response.data) ||
            error.message ||
            error.toString(),
        });
      }
    );
  }

  render() {
    return (
      <div className="grid_container">
        {/* Bruk div (block) i stedet for span */}
        <div className="viewcard23">
          <div
            data-poster-url="https://cdn.prod.website-files.com/662b702b781a74014c56d732%2F68a305181bc5a16d5cb5ee92_NevMarine_video_kort_1-poster-00001.jpg"
            data-video-urls="https://cdn.prod.website-files.com/662b702b781a74014c56d732%2F68a305181bc5a16d5cb5ee92_NevMarine_video_kort_1-transcode.mp4,https://cdn.prod.website-files.com/662b702b781a74014c56d732%2F68a305181bc5a16d5cb5ee92_NevMarine_video_kort_1-transcode.webm"
            data-autoplay="true"
            data-loop="true"
            data-wf-ignore="true"
            id="section-dark"
            className="uui-section_heroheadernew w-background-video w-background-video-atom"
          >
            <video
              id="03dad9ac-f31e-aa76-f871-b5c43ee383f2-video"
              autoPlay
              loop
              muted
              playsInline
              // Poster er bedre enn å sette background-image stil for video
              poster="https://cdn.prod.website-files.com/662b702b781a74014c56d732%2F68a305181bc5a16d5cb5ee92_NevMarine_video_kort_1-poster-00001.jpg"
              data-wf-ignore="true"
              // Hvis du ønsker object-fit: cover i CSS i stedet for inline style:
              style={{ objectFit: "cover", width: "100%", height: "100%" }}
            >
              <source
                src="https://cdn.prod.website-files.com/662b702b781a74014c56d732%2F68a305181bc5a16d5cb5ee92_NevMarine_video_kort_1-transcode.mp4"
                type="video/mp4"
                data-wf-ignore="true"
              />
              <source
                src="https://cdn.prod.website-files.com/662b702b781a74014c56d732%2F68a305181bc5a16d5cb5ee92_NevMarine_video_kort_1-transcode.webm"
                type="video/webm"
                data-wf-ignore="true"
              />
              {/* Fallback-tekst for gamle browsere */}
              Your browser does not support the video tag.
            </video>

            <div className="uui-page-padding-2" />
          </div>
        </div>
      </div>
    );
  }
}

